import { getConfigManager } from '../config';
import { createAsyncAtom } from '../lib/state';

const configAtom = createAsyncAtom(async () => getConfigManager().getConfig());

export { configAtom };
